import { render, staticRenderFns } from "./PerformanceCardItem.vue?vue&type=template&id=4ddb2557&"
import script from "./PerformanceCardItem.vue?vue&type=script&lang=js&"
export * from "./PerformanceCardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports